import { createContext, useContext, type ReactNode } from 'react'
import { usePulse } from '@/hooks/usePulse'
import type { PulseData } from '@/types'
import type { UseSupabaseResult } from '@/hooks/useSupabase'

const PulseContext = createContext<UseSupabaseResult<PulseData> | null>(null)

export function PulseProvider({ children }: { children: ReactNode }) {
  const pulse = usePulse()
  return <PulseContext.Provider value={pulse}>{children}</PulseContext.Provider>
}

export function usePulseContext() {
  const ctx = useContext(PulseContext)
  if (!ctx) throw new Error('usePulseContext must be used within PulseProvider')
  return ctx
}
